export const PRODUCTS_SUCCESS = "PRODUCTS_SUCCESS";
export const PRODUCTS_FAIL = "PRODUCTS_FAIL";
export const SINGLE_SUCCESS = "SINGLE_SUCCESS";
export const SINGLE_FAIL = "SINGLE_FAIL";
export const RESET="RESET";
export const RESET_PRODUCTS="RESET_PRODUCTS";
export const RESET_RELATED="RESET_RELATED";
export const RELATED_SUCCESS="RELATED_SUCCESS";
export const RELATED_FAIL="RELATED_FAIL";
